import { createPlayer } from "./services/native-player";
import { createApi } from "./services/api";
import type { Environment } from "./services/api";
import { debugConfig } from "./utils/debug-config";

export type MixhaloNativeConfig = {
  defaultEnvironment: Environment | null;
  credentials: { access: string; secret: string };
  userAgent: string;
  integratorName: string;
  sdkVersion: string;
  uuid: string;
  clientVersion?: string;
  authHost?: string;
  enableStreamMonitoring?: boolean;
};

export const initializeMixhalo = (config: MixhaloNativeConfig) => {
  if (config.enableStreamMonitoring) {
    debugConfig.setEnableStreamMonitoring(true);
  }

  createPlayer(config.enableStreamMonitoring);
  createApi({
    ...config,
  });
};
